import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UpdateTaskComment as UpdateTaskCommentGenerated,
  UpdateTaskCommentVariables as UpdateTaskCommentVariablesGenerated,
} from "core/queries/__generated__/UpdateTaskComment";

export const updateTaskComment = gql`
  mutation UpdateTaskComment(
    $commentId: ID!
    $deleted: Boolean
    $richBody: String
    $mentions: [ID!]
  ) {
    updateComment(
      commentId: $commentId
      newDeleted: $deleted
      newRichBody: $richBody
      newMentions: $mentions
    ) {
      comment {
        id
        body
        richBody
        mentions {
          items {
            ... on User {
              id
            }
          }
        }
      }
    }
  }
`;

export interface DeleteCommentOptions {
  id: string;
  deleted: boolean;
  richBody: string;
  mentions: string[];
}

interface UseUpdateTaskCommentQueryOptions {
  refetchQueries?: string[];
  variables?: UpdateTaskCommentVariablesGenerated;
}
export const useUpdateTaskComment = ({
  refetchQueries = [],
  variables,
}: UseUpdateTaskCommentQueryOptions) =>
  useMutation<UpdateTaskCommentGenerated, UpdateTaskCommentVariablesGenerated>(
    updateTaskComment,
    { refetchQueries, variables },
  );
